import React from 'react';
import PropTypes from 'prop-types';
import { StyledAvatar } from './style';

const Avatar = props => <StyledAvatar hover={props.hover} className="avatar" />;

Avatar.propTypes = {
  hover: PropTypes.bool
};
Avatar.defaultProps = {
  hover: true
};

export default Avatar;
